import React, { useEffect, useState } from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "../styles/ServicesProvideCards.css";
import { motion } from "framer-motion";

const Servicecards = [
  {
    image: "/images/Sec4Img1.png",
    title: "Application Development",
    text: " Scalable and secure web and mobile apps designed to grow with your business using our rapid application development platform.  ",
    button: "/services/ApplicationDevelopment",
    textClassName: "para-application",
  },
  {
    image: "/images/H_sec4_img8_pd.png",
    title: "Product Development",
    text: "Our team excels in new product development, guiding you through every phase of the product development lifecycle. ",
    button: "/services/ProductDevelopment",
    textClassName: "para-product",
  },
  {
    image: "/images/H-Sec4_img3_cld.png",
    title: "Cloud Optimization",
    text: "Maximize efficiency and security with serverless and cloud optimization solutions. ",
    button: "/services/CloudOptimization",
    textClassName: "para-cloud",
  },
  {
    image: "/images/H_sec4_img4_das.png",
    title: "Data and Analytics solutions",
    text: "Arshil’s data and analytics solutions automate the ingestion, curation, and processing of data from multiple sources to provide a 360-degree view of the data. ",
    button: "/services/DataAndAnalyticalSolutions",
    textClassName: "para-DTA",
  },
  {
    image: "/images/H_sec4_img5_QA.png",
    title: "Quality Assurance",
    text: " At Arshil, we provide comprehensive software quality assurance and quality assurance testing services to ensure your applications meet the highest standards. ",
    button: "/services/QualityAssurance",
    textClassName: "para-DTA",
  },
  {
    image: "/images/H-sec4_img6_UX.png",
    title: "UX/UI Designing",
    text: "We specialize in providing top-tier UI/UX designing services to create seamless, user-friendly interfaces for your applications.",
    button: "/services/UxUiDesigning",
    textClassName: "para-application",
  },
  {
    image: "/images/H_sec4_img7_devsc.png",
    title: "DevSecOps",
    text: "At Arshil, our experienced DevSecOps engineers integrate security into every step of the development pipeline. ",
    button: "/services/DevSecops",
    textClassName: "para-application",
  },
  {
    image: "/images/Sec4img3.png",
    title: "Staff Augmentation",
    text: "Arshil’s IT staff augmentation services provide businesses with skilled professionals to enhance their development teams.",
    button: "/services/StaffAugumentation",
    textClassName: "para-application",
  },
];

const containerVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.8,
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { type: "spring", stiffness: 70, damping: 15 },
  },
};

const ServicesProvideCards = () => {
  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleServicecards, setVisibleServicecards] = useState(3);

  useEffect(() => {
    const updateVisibleServicecards = () => {
      if (window.innerWidth <= 768) {
        setVisibleServicecards(1);
      } else {
        setVisibleServicecards(3);
      }
    };

    updateVisibleServicecards();
    window.addEventListener("resize", updateVisibleServicecards);
    return () =>
      window.removeEventListener("resize", updateVisibleServicecards);
  }, []);

  const handleNext = () => {
    if (currentIndex + visibleServicecards < Servicecards.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <motion.div
      className="Sp_container"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.2 }}
    >
      <div className="S_carousel-container_sp">
        <h2 className="S_carousel-title_sp">Services We Provide</h2>
        <p className="S_carousel-subtitle_sp">
          We provide transformative and state-of-the-art IT solutions that meet
          your unique needs and help you achieve your business goals
          efficiently.
        </p>

        <div className="S_carousel-wrapper_sp">
          <button
            className="arrow left-arrow"
            onClick={handlePrev}
            disabled={currentIndex === 0}
          >
            <MdOutlineKeyboardArrowLeft className="S_rightArrow" />
          </button>

          <div className="S_carousel_sp">
            <div
              className="S_carousel-track_sp"
              style={{
                transform: `translateX(-${
                  currentIndex * (100 / visibleServicecards)
                }%)`,
              }}
            >
              {Servicecards.map((card, index) => (
                <motion.div
                  className="S_carousel-card_sp"
                  key={index}
                  variants={cardVariants}
                >
                  <img
                    src={card.image}
                    alt={card.title}
                    className="service_image_sp"
                  />
                  <div className="S_coursal_card_tx_sp">
                    <h3>{card.title}</h3>
                    <p className={`service-title ${card.textClassName || ""}`}>
                      {card.text}
                    </p>
                    <section className="servicecard_info_button btn_pt">
                      <span className="Service_arrow_icon">&gt;</span>
                      <button
                        className="Services_btn"
                        onClick={() => navigate(card.button)}
                      >
                        Learn More
                      </button>
                    </section>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          <button
            className="arrow right-arrow"
            onClick={handleNext}
            disabled={currentIndex + visibleServicecards >= Servicecards.length}
          >
            <MdOutlineKeyboardArrowRight className="S_rightArrow" />
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default ServicesProvideCards;
